import {
    PaymentMethodDetailParameters,
    SinglePaymentParameters,
    useRepositoryQuery,
} from '@mews-commander/data-access';

export const useGetPaymentDetails = ({ paymentId }: Pick<SinglePaymentParameters, 'paymentId'>) =>
    useRepositoryQuery('paymentDetails', 'get', { paymentId });

export const usePaymentMethodDetails = (
    { id, accountId, paymentMethod }: PaymentMethodDetailParameters,
    options?: { enabled?: boolean }
) => useRepositoryQuery('paymentMethodDetails', 'get', { id, accountId, paymentMethod }, options);
